var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"app"}},[_c('MyHeader',{on:{"add":_vm.add}}),_c('MyMain',{attrs:{"list":_vm.list},on:{"del":_vm.del}}),_c('MyFooter',{attrs:{"list":_vm.list},on:{"clean":_vm.clean}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }